(function() {
	'use strict';
	angular.module('app.setup')
		.controller('projectCategoriesForm', projectCategoriesForm);

	projectCategoriesForm.$inject = ['$scope'];
	function projectCategoriesForm($scope) {
		var vm = this;
		// view model functions
		vm.projectCategory = $scope.projectCategory;
		vm.leanDirFactoryNdx = $scope.leanDirFactoryNdx;
		vm.saveCallBack = $scope.saveCallBack;
		vm.isSaveButtonDisabled = false;
		vm.action = $scope.action;
		vm.close = close;
		vm.save = save;
		init();
		
		function init() {
			vm.projectCategory = {
				factoryNdx: vm.leanDirFactoryNdx
			};
		}

		function save() {
			vm.isSaveButtonDisabled = true;
			vm.projectCategory.factoryNdx = vm.leanDirFactoryNdx;
			vm.saveCallBack(vm.projectCategory).then(function() {
				$scope.result();
				vm.isSaveButtonDisabled = false;
			});
		}
		
		function close() {
			$scope.result();
		}
	}
})();
